"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import DropPartMarkdown from "./DropPartMarkdown";
import DropListItemContentMedia from "../item/content/media/DropListItemContentMedia";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { MentionedWave } from "@/entities/IDrop";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
import { DropImageGalleryProvider } from "./DropImageGalleryProvider";
import { buildDropImageGalleryItems, getDropImageGalleryItemId } from "./dropImageGallery";
interface DropPartContentProps {
  readonly mentionedUsers: ApiDropMentionedUser[];
  readonly mentionedGroups?: ApiDropGroupMention[] | undefined;
  readonly mentionedWaves: MentionedWave[];
  readonly referencedNfts: ApiDropReferencedNFT[];
  readonly partContent: string | null;
  readonly onQuoteClick: (drop: any) => void;
  readonly currentDropId?: string | undefined;
  readonly partMedias: Array<{
    mimeType: string;
    mediaSrc: string;
  }>;
  readonly currentPartCount: number;
}
const DropPartContent: React.FC<DropPartContentProps> = t0 => {
  const $ = _c(23);
  const {
    mentionedUsers,
    mentionedGroups: t1,
    mentionedWaves,
    referencedNfts,
    partContent,
    onQuoteClick,
    currentDropId,
    partMedias,
    currentPartCount
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const mentionedGroups = t2;
  let t3;
  if ($[2] !== partContent || $[3] !== partMedias) {
    t3 = buildDropImageGalleryItems({
      partContent,
      partMedias
    });
    $[2] = partContent;
    $[3] = partMedias;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const galleryItems = t3;
  let t4;
  if ($[5] !== currentDropId || $[6] !== mentionedGroups || $[7] !== mentionedUsers || $[8] !== mentionedWaves || $[9] !== onQuoteClick || $[10] !== partContent || $[11] !== referencedNfts) {
    t4 = <div className="tw-group"><DropPartMarkdown mentionedUsers={mentionedUsers} mentionedGroups={mentionedGroups} mentionedWaves={mentionedWaves} referencedNfts={referencedNfts} partContent={partContent} onQuoteClick={onQuoteClick} currentDropId={currentDropId} /></div>;
    $[5] = currentDropId;
    $[6] = mentionedGroups;
    $[7] = mentionedUsers;
    $[8] = mentionedWaves;
    $[9] = onQuoteClick;
    $[10] = partContent;
    $[11] = referencedNfts;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== currentPartCount || $[14] !== partContent || $[15] !== partMedias) {
    t5 = !!partMedias.length && <div className={`${partContent ? "tw-mt-4" : "tw-mt-1"} tw-space-y-2`}>{partMedias.map((media, i) => <div key={`part-${currentPartCount}-media-${i}-${media.mediaSrc}`} className="tw-h-64"><DropListItemContentMedia media_mime_type={media.mimeType} media_url={media.mediaSrc} galleryItemId={media.mimeType.toLowerCase().includes("image") ? getDropImageGalleryItemId("media", i, media.mediaSrc) : undefined} /></div>)}</div>;
    $[13] = currentPartCount;
    $[14] = partContent;
    $[15] = partMedias;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <div className="tw-h-full tw-w-full">{t4}{t5}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== galleryItems || $[21] !== t6) {
    t7 = <DropImageGalleryProvider items={galleryItems}>{t6}</DropImageGalleryProvider>;
    $[20] = galleryItems;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default DropPartContent;